import { DropdownItem } from 'reactstrap'

export default function PaginationRecordMenuItem({ numberOfRecords, recordMenuItemClicked }) {
  return (
    <DropdownItem data-cy={`record-menu-item-${numberOfRecords}`} onClick={(event) => recordMenuItemClicked(event, numberOfRecords)}>{numberOfRecords}</DropdownItem>
  )
}
